import React, { Component } from 'react';
import { TileWithoutImage as Tile, ListItem } from '../../components';

class SearchResultsTilesCards extends Component {

  render() {
    if (this.props.items.length < 1) {
      return (
        <ListItem
          disabled
          primaryText={'Keine Suchergebnisse'}
          secondaryText={`Leider konnten wir keine ${this.props.type} für gewählten Suchbegriff finden`}
          secondaryTextLines={2}
        />);
    }

    return (
      <div>
        {this.props.items.map((item, i) =>
          <Tile
            className={'tile'}
            key={i}
            title={item.title}
            onClick={() => this.props.onClick(item)}
            match={item.match}
            searchTerm={this.props.searchTerm}
          />)}
      </div>
    );
  }
}

export default SearchResultsTilesCards;



// WEBPACK FOOTER //
// ./src/app/main/search/search-result-tiles-cards.js